// extracted by mini-css-extract-plugin
export default {"dashboards":"PowerBIDashboardsPage_dashboards__3lqMc","noData":"PowerBIDashboardsPage_noData__l17Bg"};